import React, { useState, useEffect, useRef, createRef } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { CSVLink, CSVDownload } from "react-csv";
import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  Upload,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import moment from "moment";
import { getProductSalesData } from "../../../Redux/actions/dailysalesActions";

const { RangePicker } = DatePicker;
const { Option } = Select;

const Index = ({ product, productName }) => {
  const dispatch = useDispatch();
  const csvlinkRef = createRef();
  const { locations } = useSelector(
    (state) => ({
      locations: state.locations.locations,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(false);
  const [formattedItems, setFormattedItems] = useState([]);
  const [datePickerValue, setDatePickerValue] = useState([
    moment().subtract(1, "months").startOf("day"),
    moment().endOf("day"),
  ]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (loading) {
      if (formattedItems.length > 0) {
        console.log("click");
        csvlinkRef.current.click();
      } else {
        message.info("no sales for that product with these parameters");
      }
      setLoading(false);
      setIsModalVisible(false);
    }
  }, [formattedItems]);

  useEffect(() => {
    if (isModalVisible) {
      setDatePickerValue([
        moment().subtract(1, "months").startOf("day"),
        moment().endOf("day"),
      ]);
      setSelectedBranch(null);
    }
  }, [isModalVisible]);

  const headers = [
    { label: "branch", key: "branch_name" },
    { label: "sale_date", key: "sale_date" },
    { label: "name", key: "name" },
    { label: "cost_peso", key: "cost_peso" },
    { label: "cost_rmb", key: "cost_rmb" },
    { label: "sell_price", key: "sell_price" },

    { label: "foodpanda qty", key: "qty_fp" },
    { label: "grab qty", key: "qty_grab" },
    { label: "regular qty", key: "qty_reg" },
    { label: "total quantity", key: "quantity_sold" },

    { label: "sell_subtotal", key: "sell_subtotal" },
  ];

  const getOrders = async () => {
    if (!loading) {
      setLoading(true);
      try {
        const props = {
          product: product,
          startDate: datePickerValue[0].format("YYYY-MM-DD HH:mm:ss"),
          endDate: datePickerValue[1].format("YYYY-MM-DD HH:mm:ss"),
          branch: selectedBranch,
        };

        const sales = await dispatch(getProductSalesData(props));
        console.log("Sales data:", sales);
        setFormattedItems(sales);
      } catch (error) {
        console.error("Error fetching sales data:", error);
        setLoading(false);
      }
    }
  };

  const showModal = () => {
    setFormattedItems([]);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    getOrders();
  };

  const handleCancel = () => {
    setLoading(false);
    setIsModalVisible(false);
  };

  return (
    <>
      {formattedItems.length > 0 ? (
        <div style={{ display: "hidden" }}>
          <CSVDownload
            data={formattedItems}
            filename={`${productName} product summary ${moment(
              datePickerValue[0]
            ).format("LL")}-${moment(datePickerValue[1]).format("LL")}.csv`}
            target="_blank"
            headers={headers}
          />
        </div>
      ) : null}
      <Button
        onClick={showModal}
        style={{ marginRight: "1rem" }}
        type="primary"
        loading={loading}
      >
        export sales
      </Button>

      <Modal
        title="Select Date Range and Location"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Form layout="vertical">
          <Form.Item label="Date Range">
            <RangePicker
              value={datePickerValue}
              onChange={(dates) => setDatePickerValue(dates)}
            />
          </Form.Item>
          <Form.Item label="Location">
            <Select
              placeholder="Select a location"
              onChange={(value) => setSelectedBranch(value)}
              value={selectedBranch}
            >
              {locations.map((location) => (
                <Option key={location.id} value={location.id}>
                  {location.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Index;
